import React, { useState, useEffect, useRef } from "react";
import {
  Grid,
  Typography,
  Box,
  Button,
  Tabs,
  Tab,
  useTheme,
  useMediaQuery,
  IconButton,
  Modal,
  Popover,
  // Tooltip,
} from "@mui/material";
import {
  generateOrderedList,
  getTextContentWithHeading,
  referenceHtml,
  generateUnOrderedList,
  referenceTootKit,
  sectionStyle,
  h1style,
  h2style,
  h3style,
  dimensionStyle,
  paraStyle,
  DividerBorderStyle,
  DashedBorderStyle,
  captionWithBorders,
  referenceStyle,
  captionStyle,
} from "./ChapterList";

import { styled } from "@mui/material/styles";
import Divider from "@mui/material/Divider";
import "../JaldiLab.css";
import CaptionWithBorders1 from "../../../components/ChapterImage/Image";
import courtPhase1 from "../../../assets/Images/Site Building  Management Images/Court_phase_diagram.jpg";
import sm_update from "../../../assets/Images/Site Building  Management Images/SM_update.jpg";
import bms_update from "../../../assets/Images/Site Building  Management Images/BMS_Update.jpg";
import sbs_update from "../../../assets/Images/Site Building  Management Images/SBS_update.jpg";
import { FigureDesc72, FigureDesc73, FigureDesc74, FigureDesc75 } from "../../../utils/tmp/ImageDescription/SiteAndBuildingID";

const SiteAndBuilding = ({ goToSection }) => {
  const theme = useTheme();

  const reference = (_data, number) => {
    return referenceTootKit(_data, number, handleScrollToReferences);
  };
  const referencesRef = useRef(null);

  const handleScrollToReferences = () => {
    if (referencesRef.current) {
      referencesRef.current.scrollIntoView({
        block: "center",
        inline: "nearest",
        behavior: "smooth",
      });
    }
  };

  const generateCustomOrderedList = (_stringsArray, type) => {
    return (
      <Typography>
        <ol type={type}>
          {_stringsArray.map((text, index) => (
            <li style={{ ...pointStyle, paddingLeft: "10px" }} key={index}>
              {text}
            </li>
          ))}
        </ol>
      </Typography>
    );
  };

  const referenceData = [
    // {
    //   content: [
    //     <> ‘Handbook of Conservation of Heritage Buildings’ (<i>Central Public Works Department,</i> July 2013) </>,
    //   ],
    //   link: ["https://cpwd.gov.in/Publication/conservationhertbuildings.pdf"],
    //   description: [
    //     "<https://cpwd.gov.in/Publication/conservationhertbuildings.pdf>",
    //   ],
    // },
    {
      content: (
        <>
          ‘Handbook of Conservation of Heritage Buildings’ (
          <i>Central Public Works Department,</i> July 2013)
        </>
      ),
      link: "https://cpwd.gov.in/Publication/conservationhertbuildings.pdf",
      description: (
        <>
          {" "}
          &lt;https://cpwd.gov.in/Publication/conservationhertbuildings.pdf&gt;.
          See also: ‘Guidelines for Conservation’{" "}
          <i>(Indian National Trust for Art and Cultural Heritage)</i>{" "}
          &lt;http://www.intach.org/about-charter-guidelines.php#b3&gt;{" "}
        </>
      ),
    },
    {
      content: (
        <>
          Brandon Lewis, ‘Transform Smart Building Data into KPIs that Matter’ (
          <i>Insight.Tech,</i> 17 September 2020)
        </>
      ),
      link: "https://www.insight.tech/content/transform-smart-building-data-into-kpis-that-matter",
      description:
        " <https://www.insight.tech/content/transform-smart-building-data-into-kpis-that-matter>",
    },
    {
      content:
        "While AutoCAD and compatible systems have been widely accepted as the documentation standards in the building industry, BIM formats include digital representation of the building and in-built 3D capabilities to enable error free multi-system infrastructure layouts, construction  monitoring/change  management tools, etc., It is suggested that all design outputs and archived building or infrastructure plans under the e-Courts project should be in the BIM format. ",
    },
    {
      content: (
        <>
          ‘LEED Rating System’ <i>(U.S. Green Building Council)</i>{" "}
        </>
      ),
      link: "https://www.usgbc.org/leed",
      description: "<https://www.usgbc.org/leed> ",
    },
    {
      content: "ECBC (2017). ",
    },
    {
      content: (
        <>
          ‘Urban and Regional Development Plans Formulation and Implementation
          (URDPFI) Guidelines’{" "}
          <i>(Ministry of Urban Development, Government of India)</i>{" "}
        </>
      ),
      link: "https://mohua.gov.in/upload/uploadfiles/files/URDPFI%20Guidelines%20Vol%20I(2).pdf",
      description:
        "<https://mohua.gov.in/upload/uploadfiles/files/URDPFI%20Guidelines%20Vol%20I(2).pdf> p. 199.",
    },
    {
      content: (
        <>
          ‘A Handbook of Landscape’ <i>(Central Public Works Department)</i>{" "}
        </>
      ),
      link: "https://cpwd.gov.in/Publication/LandscapeBook.pdf",
      description: "<https://cpwd.gov.in/Publication/LandscapeBook.pdf>",
    },
    {
      content: "Disaster Management Act (2005), sections 37(1) and 40.",
    },
    {
      content:
        "Some High Courts have provisions for Disaster Management strategies in this regard. For example, the High Court of Himachal Pradesh has developed an Action Plan on Disaster Management, available here: ",
      link: "https://districts.ecourts.gov.in/sites/default/files/Action%20Plan%20on%20National%20Disaster%20Management.pdf",
      description:
        "<https://districts.ecourts.gov.in/sites/default/files/Action%20Plan%20on%20National%20Disaster%20Management.pdf>",
    },
    {
      content:
        "This includes medical officers, engineers, fire officers, home guards/security officers, etc.",
    },
    {
      content:
        "A Building Data model is a conceptual model that diagrammatically represents the structure and flow of data elements, and relationships between them, within the information systems of a building. In the design of Courts, a building data model would serve as a blueprint for implementing building management systems. Data modelling (the process of developing a data model) provides outputs that can be analysed and used for effective decision-making and better management of the building systems.",
    },
    {
      content: "NBC (2016), Vol I Part 4, section 4.10, p. 52.",
    },
    {
      content: "NBC (2016), p. 89 (Annexures)",
    },
  ];

  const retrofittingPlanArray = [
    "The Plan should outline the needs, goals and objectives for retrofitting the space through stakeholder engagement and user experience survey.",
    "It should include an audit process, which engages with the concerned stakeholders, to evaluate the existing building and its facilities or equipment for their performance and efficiency, in accordance with the goals and objectives of the retrofitting.",
    "The retrofitting options should be determined with an understanding of the potential risks and opportunities for accommodating improvements. The technical and economic viability, costs and benefits and resource availability should also be taken into accounting while preparing the plan.",
    "Detailed plans and drawings of the design solutions should be prepared in consultation with stakeholders such as facility managers, engineers, contractors, and users, to ensure that the design meets their needs and expectations.",
    "The plan should include a post-implementation evaluation to assess the efficacy of the retrofitting",
    "A work plan with a budget and a schedule for implementation, monitoring and evaluation should be prepared for implementing the designs as per schedule.",
    "The retrofitted facility/system or space needs to be maintained and necessary training and capacity building programs should be conducted to optimise the use, and maximise the benefits and lifespan of the building.",
  ];
  const siteAndBuildingArray = [
    "Physical assets such as furniture, plumbing, wiring, elevators, and heating and cooling, digital technology;",
    "Soft service systems that would require human power such as waste management, security, landscaping, maintenance of hygiene, space planning and workplace design, wayfinding, building maintenance and site landscaping services; and",
    "Security and safety services such as visitor management, fire safety systems, emergency or quick response, and access control systems.",
  ];
  const disasterManagementOneArray = [
    "Assessing the risks, capacity and vulnerability of the Court Complex towards various types of hazards, both natural and man-made, including assessing compliance of the Court Complex buildings with the NBC norms for fire and life safety.",
    "Conducting an inventory of available internal resources such as fire alarm, fire extinguisher, water tank facility, etc., and external resources such as ambulance services, police station, fire station, hospital, etc., to identify resources to be procured for better preparedness.",
    "Constituting a  Quick Response Team consisting of Court officials who may be identified and trained in measures to be taken for prevention, mitigation, preparedness and response to various hazards and use of equipment and technology for disaster management. ",
    "Developing programs and training and capacity building sessions in collaboration with other Government Agencies and the DDMA to disseminate the evacuation plan to all stakeholders.",
    "Preparing SoPs for prevention of fires, evacuation, first aid, search and rescue, and security/threat management audit in consultation with Jurisdictional Law Enforcement, Fire & Civil Defence Officials of the State.",
  ];
  const disasterManagementTwoArray = [
    "Preparing building evacuation plans with evacuation routes, assembly points, refuge areas, nearest exits, location of fire extinguishers, etc., marked on a floor plan.",
    "Determining strategic locations within the Court Complex where the floor plan must be displayed  including  all public areas, workspaces and at the entrance lobby.",
    "Designing and implementing  accessible signage systems and mechanisms for information flow and alerts for emergency situations using technology.",
    "Preparing plans for using Lead Protection System, which is a portable security tool used to escort vulnerable stakeholders from the area of threat to a safe place, in case of emergencies.",
    <>
      Updating the evacuation plan on a periodic basis based on information
      collected from the building data model{reference(referenceData[10], 11)}{" "}
      of the Building Management system.
    </>,
    "Conducting regular mock drills for emergency situations.",
    "Preparing security response protocol for the Quick Response Teams to operate at the time of emergencies.",
    "Preparing procedures and methods for monitoring, evaluation, and maintenance of the Disaster Management Plan, including periodic evaluation and updation of the said procedures in consultations with the DDMA.",
  ];

  const pointStyle = {
    fontFamily: "Lato",
    fontSize: "18px",
    fontWeight: "400",
    lineHeight: "27px",
    color: "#555555",
    letterSpacing: "0em",
    textAlign: "justified",
    margin: "10px 30px",
  };

  return (
    <div>
      <Typography>
        <h1 id="partD" style={h1style}>
          PART D – IMPLEMENTATION, MONITORING & EVALUATION
        </h1>
        <h2 id="recommendationForSite" style={h2style}>
          <span style={{ fontSize: "24px" }}>2. </span>RECOMMENDATION FOR SITE
          AND BUILDING MANAGEMENT
        </h2>
        <h3 id="phasingPlan" style={h3style}>
          <span style={{ fontSize: "20px" }}>2.1. </span>Phasing Plan for New
          Constructions
        </h3>
        <p style={paraStyle}>
          To determine the future capacity requirements and additional functions
          that a Court Complex has to accommodate in the long term, stakeholder
          consultations and review of the number of pending cases, including
          those to be taken up online should be conducted. Subsequently, a
          Phasing Plan that outlines a schedule of actions to be undertaken
          during all stages of the project development should be prepared. It
          must include a detailed timeline with dates for deliverables at each
          stage.
        </p>
        <p style={paraStyle}>
          At the Pre-design stage, when the project scope is defined and at the
          Design stage, the Court Complex Master Plan should identify the phases
          in which the future development activity would take place. Resources
          and space must be allocated accordingly.
        </p>
        <p style={paraStyle}>
          The Phasing Plan must anticipate and manage future requirements of
          spaces and functions, including amenities, and ensure better
          adaptation of existing spaces when transitioning from one use to
          another. When accounting for future additions the Court building must
          be designed to have structural redundancies to accommodate additional
          floors. The extensions to the building must be added without
          construction flaws and with minimum maintenance costs. A well-planned
          and managed project should ensure flexibility to add new functions and
          avoid the need to look for another site or building to accommodate
          additional facilities.
        </p>

        <CaptionWithBorders1
          image={[courtPhase1]}
          isZoom={true}
          caption="Figure 72: Examples of Phasing Plans and Schedules which may be used by Courts"
          zoomImgStyle={{ height: "550px" }}
          imageDescription={FigureDesc72}
        />

        <p style={paraStyle}>
          For example, if a new Court Complex is planned to have four Courtrooms
          based on its existing caseload, and the aim is to accommodate 15
          Courtrooms in the long term, a Phasing Plan should be prepared to
          manage the first phase of development from inception to
          implementation. The Plan should anticipate the budget and resources
          required for future expansion. As part of the Phasing Plan, space for
          future expansion should be allocated in the Court Complex Master Plan,
          either horizontally on the site or vertically in accordance with the
          local building regulations.
        </p>
        <p style={paraStyle}>
          The design principles and the spatial design considerations of this
          Handbook should be taken into account when preparing the Phasing Plan.
        </p>
        <DashedBorderStyle />
        <h3 id="retrofittingPlan" style={h3style}>
          <span style={{ fontSize: "20px" }}>2.2. </span>Retrofitting Plan for
          Upgrading Existing Buildings
        </h3>
        <p style={paraStyle}>
          For retrofitting and upgrading of existing buildings, a Retrofitting
          Plan, which meets the Court design principles and spatial design
          considerations of this Handbook, should be prepared to ensure that the
          existing spaces can suitably accommodate the proposed changes.
        </p>
        <p style={paraStyle}>
          The Retrofitting Plan should take into account the following
          considerations:
        </p>
        {generateUnOrderedList(retrofittingPlanArray)}

        <CaptionWithBorders1
          image={[sm_update]}
          isZoom={true}
          caption="Figure 73: Stages involved in the retrofitting process"
          zoomImgStyle={{ height: "550px" }}
          imageDescription={FigureDesc73}
        />

        <p style={paraStyle}>
          For example, if an existing Court Complex needs to be upgraded to
          ensure accessibility, the Retrofitting Plan must outline steps to
          manage the interventions of accessibility measures to ensure least
          disruption and optimum use of spaces. It must also ensure inclusion of
          diverse sets of users through stakeholder consultations and surveys.
          The Plan must include a method for conducting an audit of existing
          accessibility features and assess the requirement for additional
          facilities, including time, resources and budget for implementing the
          same.
        </p>
        <p style={paraStyle}>
          Specific capacity building and sensitisation programs must be included
          in the plan to ensure proper implementation. For further details,
          please refer to{" "}
          <span
            onClick={() => goToSection("capacityBuilding", "mainheading")}
            style={sectionStyle}
          >
            Section 5
          </span>
          . Additionally, an assessment framework must be prepared and an
          evaluation must be conducted using the User Experience Survey which is
          based on the design principles and the spatial design considerations
          of this Handbook. For further details, please refer to{" "}
          <span
            onClick={() => goToSection("monitoringEvaluation", "mainheading")}
            style={sectionStyle}
          >
            Section 6
          </span>
          .
        </p>
        <p style={paraStyle}>
          In such instances where historic buildings are adapted or repurposed
          for use as a Court Complex, the historic character of the building
          must be protected. The prevalent local building regulations and the
          requirements for historic conservation (if applicable) need to be
          followed.{reference(referenceData[0], 1)}
        </p>
        <DashedBorderStyle />
        <h3 id="buildingManagementSystems" style={h3style}>
          <span style={{ fontSize: "20px" }}>2.3. </span>Building Management
          Systems
        </h3>
        <p style={paraStyle}>
          It is essential to adopt a control system that can monitor and manage
          the mechanical, electrical and electro-mechanical services in the
          Court Complex. A Building Management System (“BMS”) should be put in
          place to centrally control and monitor all services including
          security, power, heating, ventilation, air-conditioning, physical
          access control, pumping stations, elevators, lights and information
          and communication technology systems. Such a system aims to provide an
          optimum solution for enhanced building performance, improved energy
          efficiency, increased environmental sustainability and a comfortable,
          safe, and efficient environment.{reference(referenceData[1], 2)}
        </p>
        <p style={paraStyle}>
          Additionally, adoption of a Building Information Modelling (“BIM”)
          facilitates a process for designers and construction professionals to
          provide a complete solution for the life cycle of the building from
          the design stage to construction and further to operation. Real-time
          data from the BMS can be integrated into a BIM to aid the facility
          managers to manage the building operations sustainably.
          {reference(referenceData[2], 3)}
        </p>

        <CaptionWithBorders1
          image={[bms_update]}
          isZoom={true}
          caption="Figure 74: Representation of the operations of the Building Management System"
          zoomImgStyle={{ height: "500px" }}
          imageDescription={FigureDesc74}
        />

        <DashedBorderStyle />
        <h3 id="siteAndBuilding" style={h3style}>
          <span style={{ fontSize: "20px" }}>2.4. </span>Site and Building
          Facilities Management
        </h3>
        <p style={paraStyle}>
          To manage space usage in an optimal and efficient manner, organise the
          storage of materials and equipment, ensure a cost effective
          environment and design an enhanced workplace experience that is
          contextually sensitive and environmentally friendly, it is essential
          to appoint an agency for facilities management services with a
          Facilities Manager. The appointment of such an agency would help
          ensure the functionality, comfort, safety, efficiency and
          sustainability of buildings and grounds, and the physical
          infrastructure within a Court Complex.
        </p>
        <p style={paraStyle}>
          Facility management services would include management of the
          following:
        </p>
        {generateCustomOrderedList(siteAndBuildingArray, "a")}

        <p style={paraStyle}>
          The scope of work of the Facility Manager may be determined depending
          on the stage of construction or occupancy of the District Court
          Complex. The agency can facilitate and ensure adequate procurement of
          amenities, conduct regular maintenance checks for various spaces
          including sanitary provisions, and guide the budgetary allocations for
          the Court Complex depending on the specific needs. Dedicated funding
          to support the functioning of such an agency should be arranged to
          ensure regular management and maintenance of site and building
          services. For further details, please refer to{" "}
          <span
            style={sectionStyle}
            onClick={() => goToSection("annexes", "HeadingAnnexure8")}
          >
            Annexure 8
          </span>
          .
        </p>

        <DashedBorderStyle />
        <h3 id="sustainableBuildingStrategies" style={h3style}>
          <span style={{ fontSize: "20px" }}>2.5. </span>Sustainable Building
          Strategies
        </h3>
        <p style={paraStyle}>
          The High Court should establish a Sustainable Building Policy to
          ensure that all District Court buildings under its jurisdiction adhere
          to sustainable practices. It is recommended that a comprehensive
          approach be developed to meet the green building standards outlined by
          either the IGBC building rating system or the LEED rating system.
          {reference(referenceData[3], 4)} The District Court buildings should
          be planned to incorporate and maintain sustainable features, including
          ecologically sensitive transformation of the site; adoption of
          measures for natural light and ventilation; energy and water-saving
          systems and fixtures; and systems for waste disposal, health and
          hygiene. Locally sourced, renewable and eco-friendly materials should
          be used in the construction of all District Courts.
        </p>
        <p style={paraStyle}>
          Additionally, Court buildings should meet the minimum requirements for
          the energy-efficient design and construction of buildings specified in
          the Energy Conservation and Sustainable Building Code, 2017
          {reference(referenceData[4], 5)} and the Generic Energy Efficiency
          Guidelines.{reference(referenceData[5], 6)}
        </p>
        <p style={paraStyle}>
          While preparing the Master Plan for a Court Complex, strategies for
          incorporating soft landscape with a sustainable approach should be
          adopted.{reference(referenceData[6], 7)}
        </p>
        <p style={paraStyle}>
          For waste disposal and management, the Policy should also lay out
          systems for recycling of old records, documents, and old or broken
          furniture and equipment. Additionally, in coordination with the local
          Municipal authorities, systems for disposal of sanitary/medical waste
          and garbage, should be put in place to ensure sustainable waste
          management practices in all District Courts. This includes adopting
          sustainable measures for disposal of wet waste and recycling of
          wastewater at the site level.
        </p>

        <CaptionWithBorders1
          image={[sbs_update]}
          isZoom={true}
          caption="Figure 75: Methods and benefits of sustainable construction"
          zoomImgStyle={{ height: "500px" }}
          imageDescription={FigureDesc75}
        />

        <DashedBorderStyle />
        <h3 id="disasterManagementStrategies" style={h3style}>
          <span style={{ fontSize: "20px" }}>2.6. </span>Disaster Management
          Strategies
        </h3>
        <p style={paraStyle}>
          District Courts should incorporate and follow the provisions of the
          <span style={dimensionStyle}>
            {" "}
            Disaster Management Act (2005) which provides institutional and
            operational frameworks for disaster prevention, mitigation,
            response, preparedness, and recovery at all levels
          </span>
          . The Act envisages the formation of the District Disaster Management
          Authority (“DDMA”) headed by the District Collector/Deputy
          Commissioners and co-chaired by the elected representatives of local
          authorities.
        </p>
        <p style={paraStyle}>
          In coordination with the respective DDMAs, a Disaster Management Plan
          {reference(referenceData[7], 8)} with Standard Operating Procedures
          (“SoPs”) should be prepared by the High Court for District Courts
          under their jurisdiction. The Plan and the SoPs should make provision
          for planning, organising, coordinating and implementing measures for
          effective response and management during emergencies and disasters.
          {reference(referenceData[8], 9)}
        </p>
        <p style={paraStyle}>
          At the District-level, a Court Disaster Management & Emergency
          Response Coordination Committee should be set up comprising
          representatives from the District Court such as Judges, lawyers, and
          the Facility Manager (
          <span
            onClick={() =>
              goToSection("siteBuildingManagement", "siteAndBuilding")
            }
            style={sectionStyle}
          >
            Section 2.4{" "}
          </span>{" "}
          ), and representatives from the relevant local authorities.
          {reference(referenceData[9], 10)} This Committee should be charged
          with the monitoring and implementation of the Disaster Management Plan
          and supervision of all the quick response teams.
        </p>
        <p style={paraStyle}>
          The Committee should undertake the following functions:
        </p>
        {generateUnOrderedList(disasterManagementOneArray)}

        <p style={paraStyle}>
          Further, SoPs may be prepared for the following aspects of Disaster
          Management:{" "}
        </p>
        {generateUnOrderedList(disasterManagementTwoArray)}

        <p style={paraStyle}>
          Additionally, a qualified Fire Officer with experience of not less
          than three years, must be appointed, who must be available on the
          premises or in the District Fire Department (in close proximity), to
          maintain all equipment and prepare Fire Orders and fire operational
          plans.{reference(referenceData[11], 12)}
        </p>
        <p style={paraStyle}>
          Third party auditors should be engaged to assess the efficiency of the
          disaster management policies and emergency protocols and recommend
          periodic revisions to the SoPs.{reference(referenceData[12], 13)}
        </p>

        <h2 ref={referencesRef} id="siteRef" style={referenceStyle}>
          References
          <Divider />
        </h2>
        {referenceHtml(referenceData)}
      </Typography>
    </div>
  );
};

export default SiteAndBuilding;
